var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("activator",function(){return [_vm._v(" Log Out ")]},{"logout":_setup.logout})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }